<template>
    <div class="list-allcontacts" v-if="!openMessage">
      <div>
          <input
              type="text"
              v-model="searchQuery"
              placeholder="Type to search conversation..."
              class="search-input"
          />
      </div>

      <ul class="overflow-contacts" v-if="filteredContacts.length > 0">
          <li v-for="contact in filteredContacts" :key="contact.id" @click="openConversation(contact.id)">
              <span>{{ truncateName(`${contact.firstName} ${contact.lastName}`) }}</span>
              <span v-show="!clearedNotifications.has(contact.id)" class="notification-badge" :class="{ hidden: contact.notSeen == 0 }">
                New Messages ({{ contact.notSeen }})
              </span> 
          </li>
      </ul>
      <div v-else-if="loading" class="loader">
        <i class="fa fa-spinner fa-spin"></i>
      </div>
      <div v-else class="contacts">
          <div class="contacts">
              <div class="no-contacts">
                  <i class="fa fa-comment-alt"></i>
                  <h2>Looks like you don't have any conversation yet.</h2>
              </div>
          </div>
      </div>
    </div>

    <BoxMessageTab @returnList="returnList" :titleConversation="titleConversation" :myPersonId="myPersonId" :messages="messages" v-else></BoxMessageTab>
</template>
<script>
  import axios from 'axios';
  import BoxMessageTab from './BoxMessageTab.vue';
  export default {
    components: {
      BoxMessageTab
    },
    props: ['myPersonId'],
    data: function() {
      return {
        contacts: [],
        patients: [],
        messages: [],
        searchQuery: "",
        items: [],
        openMessage: false,
        loading: false,
        titleConversation: '',
        clearNotification: false,
        clearedNotifications: new Set(),
      };
    },
    computed:{
      filteredContacts() {
        const query = this.searchQuery.toLowerCase();
        return this.contacts.filter((contact) =>
          `${contact.firstName} ${contact.lastName}`.toLowerCase().includes(query)
        );
      },
    },
    mounted() {
      this.getAllUsers();
    },
    methods: {
      truncateName(name) {
        return name.length > 20 ? name.substring(0, 20) + '...' : name;
      },
      returnList() {
        this.openMessage = false;
      },
      getAllUsers() {
        this.loading = true;
        axios
          .get(`/api/v1/messages/users/conversation`)
          .then((response) => {
            if (response.data.data) {
              let contact = response.data.data;
              if(contact){
                this.contacts = contact
              }
            }
            this.isPollingPaused = false;
          })
          .catch(
            function(error) {
              this.isPollingPaused = false;
            }.bind(this)
          )
          .finally(() => {
            this.loading = false;
          });
      },
      openConversation(user_id) {
        this.clearedNotifications.add(user_id);
        this.isPollingPaused = true;
        axios
          .get(`/api/v1/messages/users/${user_id}`)
          .then((response) => {

            if (response.data.data) {
                this.titleConversation = response.data.data;
            }
          });

        axios
          .get(`/api/v1/messages/users/conversation/${user_id}`)
          .then((response) => {
            if (response.data.data) {
              this.openMessage = true;
              let messages = response.data.data;

              this.messages = messages;
            }
            this.isPollingPaused = false;
          })
          .catch(
            function(error) {
              this.isPollingPaused = false;
            }.bind(this)
          );
      },
    },
  };
</script>

<style type="sass" scoped>
.list-allcontacts{

  .overflow-contacts{
    height: 394px;
    overflow-y: scroll;
  }

  ul{
    list-style: none;
  }

  li{
    padding: 10px;
    border-bottom: 1px solid #ccc;
    width: 343px;
    cursor: pointer;
  }

  li:hover{
    background-color: #eaeaea;
  }

  li::before{
    content: '';
  }
}

.loader{
  height: 425px;
  padding: 45%;
}
.search-input{
    margin: 0px !important;
}

.contacts {
  position: relative;
  .no-contacts {
    padding: 3rem 1.5rem;
    background-color: #fff;
    i {
      color: #243153;
      display: block;
      font-size: 5rem;
      margin-bottom: 1rem;
      text-align: center;
    }
    h2 {
      color: #243153;
      font-size: 1.5rem;
      text-align: center;
    }
    span {
      display: block;
      text-align: center;
    }
  }

  .contacts {
    background-color: #fff;
    height: 425px;
    overflow-y: auto;
    padding: 10px
  }

}
  .notification-badge {
    position: relative;
    display: block;
    color: #0cb9b0;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    line-height: 24px;
    font-family: Arial, sans-serif;
    float: right;
    margin-right: 10px;
  }


  .notification-badge.hidden {
    display: none;
  }

</style>


// WEBPACK FOOTER //
// resources/assets/js/ConversationsTab.vue